import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { StrikeWeightDesignMode, type StrikeWeightDesignTarget } from '@/lib/piano/touch-design/design/strike-weight-design';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
export const useStrikeWeightRecommendation = (strikeWeightDesignMode, strikeWeightDesignTarget, setStrikeWeightDesign) => {
  const $ = _c(5);
  const isFirstRender = useRef(true);
  let t0;
  let t1;
  if ($[0] !== setStrikeWeightDesign || $[1] !== strikeWeightDesignMode || $[2] !== strikeWeightDesignTarget) {
    t0 = () => {
      if (isFirstRender.current) {
        if (strikeWeightDesignMode === null && strikeWeightDesignTarget === null) {
          setStrikeWeightDesign(StrikeWeightDesignMode.Smoothed, SmoothStrategy.LeastSquaresRegression);
        }
        isFirstRender.current = false;
      }
    };
    t1 = [isFirstRender, setStrikeWeightDesign, strikeWeightDesignMode, strikeWeightDesignTarget];
    $[0] = setStrikeWeightDesign;
    $[1] = strikeWeightDesignMode;
    $[2] = strikeWeightDesignTarget;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};